<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        
        payload.domain = Endpoints.domain;//nao remover, usado para apresentar a foto
        payload.getCoursesTypes();
        payload.filter();
    },
    methods:{
        filter: function(){
            let state = this;
            state.items = [];
            
            Request.do(state, 'POST', Request.getDefaultHeader(state),state.filters, `${Endpoints.curriculums.search}`,
            (response)=>{//SUCCESS CALLBACK
                state.items = response.results;
                state.totalCurriculums = state.items.length; 
            },
            (error)=>{//ERROR CALLBACK
            });
        },
        getCoursesTypes: function(){
            let state = this;
            Request.do(state, 'GET', Request.getDefaultHeader(state),null, `${Endpoints.helpers.listCnhTypes}`,
            (response)=>{//SUCCESS CALLBACK
                state.coursesTypes = response.results;
            },
            (error)=>{//ERROR CALLBACK
            });
        },
        selectItem: function(item){
            this.$emit('load-item', item);
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
